import React from 'react';
import { METRIKA_GOALS, reachGoal } from '../analytics';

function AboutMe() {
  const facts = [
    {
      tag: '01 / наука',
      fact: 'Кандидат наук · MBA',
      caption: 'и действующая исследовательская программа докторской',
      href: '#science',
    },
    {
      tag: '02 / школа',
      fact: '3 уровня подготовки руководителя',
      caption: 'от открытых лекций до персональной программы развития лидера',
      href: '#school',
    },
    {
      tag: '03 / ИИ-решения',
      fact: 'Корпоративные ИИ-проекты',
      caption: 'от управленческой задачи к работающему решению',
      href: '/ai/',
      goal: METRIKA_GOALS.SELECT_AI,
    },
    {
      tag: '04 / выступления',
      fact: '4 доклада · РБК: эфир и интервью',
      caption: 'Data Fusion, ByData, Data Fest, Концептуальный форум, РБК',
      href: '#talks',
    },
  ];

  return (
    <>
      <section id="top" className="hero-section">
        <div className="hero-content">
          <div className="hero-kicker">
            <span>00</span>
            <p>Авторская платформа о людях, управлении и искусственном интеллекте</p>
          </div>

          <div className="hero-copy">
            <p className="eyebrow">glotov.pro / манифест</p>
            <h1>Управление в эпоху ИИ</h1>
            <p className="hero-deck">
              Как руководителю мыслить, принимать решения и строить продукты в
              среде искусственного интеллекта.
            </p>
            <div className="hero-byline">
              <strong>Алексей Глотов</strong>
              <span>
                исследователь, предприниматель, эксперт по управленческим
                технологиям и ИИ
              </span>
            </div>
            <div className="hero-actions" aria-label="Основные действия">
              <a className="button button-primary" href="#directions">
                Выбрать формат работы
              </a>
              <a className="button button-secondary" href="#school">
                Открытые лекции
              </a>
            </div>
          </div>

          <div className="hero-portrait">
            <img src="/photo.webp" alt="Алексей Глотов" fetchpriority="high" />
            <div className="portrait-caption">
              Наука, бизнес и технологии как единая управленческая практика
            </div>
          </div>

          <nav className="fact-strip" aria-label="Экспертиза в цифрах">
            {facts.map((item) => (
              <a
                className="fact-cell"
                href={item.href}
                key={item.href}
                data-metrika-goal={item.goal}
                onClick={item.goal ? () => reachGoal(item.goal) : undefined}
              >
                <span className="fact-tag">{item.tag}</span>
                <strong>{item.fact}</strong>
                <p>{item.caption}</p>
              </a>
            ))}
          </nav>
        </div>
      </section>

      <section id="manifest" className="section about-section">
        <div className="section-heading">
          <p className="eyebrow">Манифест</p>
          <h2>ИИ не отменяет управление. Он повышает требования к мышлению руководителя</h2>
        </div>
        <div className="about-grid">
          <div className="about-text">
            <p>
              Я работаю с управленцами и компаниями, которым важно не просто
              “внедрить ИИ”, а перестроить способ видеть систему, принимать
              решения и собирать продукты вокруг реальных задач.
            </p>
            <p>
              В моей практике соединяются научная строгость, бизнес-логика и
              продуктовая работа с искусственным интеллектом. Это позволяет
              говорить об ИИ не как о модной технологии, а как о новой среде
              управленческого действия.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutMe;
